export const assignEVTDataIntoForm = function (evtHomePage) {
    console.log(evtHomePage);
    let userSelections = JSON.parse(localStorage.getItem("userSelections"));
    console.log(userSelections);
    if (userSelections == undefined || userSelections==null || userSelections.length === 0) {
        window.location.href = evtHomePage;
    }
    let calculatedScore = localStorage.getItem("calculatedScore");
    let urlParms = new URLSearchParams(localStorage.getItem("urlParms"));
    let url = localStorage.getItem("url");

    //Assigning User Selected answers into form hidden input fields
    let hiddenInputs = document.querySelectorAll('form.EPiServerForms section input[type="hidden"]');

    //let userSelections = selectedData != undefined? JSON.parse(selectedData):"";
    if (typeof userSelections == 'object') {
        for (let [index, dt] of userSelections.entries()) {
            hiddenInputs[index].value = (dt[0]['SelectedAns'])[0]['BlockTitle'];
        }
    }

    //Score Value
    let scoreInput = document.querySelectorAll('form.EPiServerForms section input[type="hidden"][value="en_GLO-CDO-Tool_FinalScore-Global"]')[0];
    scoreInput.value = calculatedScore != undefined ? calculatedScore : "" ;

    //UTM Values
    let hiddenFields = document.querySelectorAll('form.EPiServerForms section input[type="hidden"]');
    let len = hiddenFields.length;
    //let urlParms = new URLSearchParams(parms);

    if (urlParms.has("utm_content")) {
        hiddenFields[len - 1].value = urlParms.get("utm_content");
    }
    if (urlParms.has("utm_term")) {
        hiddenFields[len - 2].value = urlParms.get("utm_term");
    }
    if (urlParms.has("utm_campaign")) {
        hiddenFields[len - 3].value = urlParms.get("utm_campaign");
    }
    if (urlParms.has("utm_medium")) {
        hiddenFields[len - 4].value = urlParms.get("utm_medium");
    }
    if (urlParms.has("utm_source")) {
        hiddenFields[len - 5].value = urlParms.get("utm_source");
    }
    hiddenFields[len - 6].value = url;

    localStorage.removeItem("userSelections")
        .removeItem("calculatedScore")
        .removeItem("urlParms")
        .removeItem("url");
};
